<template>
  <div>
    <LeftSidebar
      :visible="visible"
      baseClass="parvandeh-status-wrapper"
      :title="title"
      :width="500"
      @close="close"
    >
      <template>
        <div class="padding-16">
          <Content
            target="person"
            :totalIncompleteItemCount="totalIncompleteItemCount"
            :percent="percent"
            :hasHeader="false"
            :loading="loading"
            :items="items"
            :parvandehCode="code"
          />
        </div>
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import LeftSidebar from "@/components/re-design/sidebar/LeftSidebar.vue";
import Content from "@/components/re-design/parvandeh-notification/Content.vue";
import { getParvandehStatusDetail } from "@/services";

export default {
  components: { LeftSidebar, Content },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    code: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      totalIncompleteItemCount: 0,
      percent: 0,
      items: [],
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        value && this.getItems();
      },
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    reset() {
      this.totalIncompleteItemCount = 0;
      this.percent = 0;
      this.items = [];
    },
    async getItems() {
      try {
        this.reset();
        this.show = true;
        this.loading = true;
        const response = await getParvandehStatusDetail(this.code);
        const { totalIncompleteItemCount, percent, items } = response;
        this.totalIncompleteItemCount = totalIncompleteItemCount;
        this.percent = percent;
        this.items = items;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
